import React from 'react';
import Styles from './contactUs.module.scss';
import image from '../../../assets/contact-us.webp';
import phoneLogo from '../../../assets/phone.webp';

function ContactUsMain() {
  return (
    <div className={Styles.container}>
      <div className={Styles.upperDiv}>
        <div className={Styles.backgroundImg}>
          <img src={image} alt="" />
        </div>
        <div className={Styles.text}>
          <h1>Get In Touch</h1>
          <p>Want to get in touch? We'd love to hear from you. Here's how you can reach us..</p>
        </div>
      </div>
      <div className={Styles.lowerDiv}>
        <div className={Styles.phone}>
          <div className={Styles.phoneLogo}>
            <img src={phoneLogo} alt="" />
          </div>
          <h3>Contact Us</h3>
          <div className={Styles.formContainer}>
            {/* Formspree form */}
            <form action="https://formspree.io/f/xeqyvbwe" method="POST" className={Styles.form}>
              <div className={Styles.formField}>
                <label htmlFor="name">Name:</label>
                <input type="text" id="name" name="name" required />
              </div>
              <div className={Styles.formField}>
                <label htmlFor="email">Email:</label>
                <input type="email" id="email" name="email" required />
              </div>
              <div className={Styles.formField}>
                <label htmlFor="message">Message:</label>
                <textarea id="message" name="message" required></textarea>
              </div>
              <button type="submit">Send Message</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export { ContactUsMain };
